var App = ( function( document, window ) {

	function App() {

	}

	App.prototype.init = function() {
		this.animationDuration = 600;

		// Crucial for all pages
		this.initSelectors();
		this.initPageTransitions();
		this.initMainNav();
		this.initMiddleNav();
		this.initAOS();

		// Page-specific
		this.initMasonry();
		this.initHomepageSlider();
		this.initAboutSliders();
		this.initCultureSlider();
		this.initInsightSlider();
		this.initBlob();
		this.initServicesBlob();
		this.initServicesSection();
		//this.initServicesAnimation();
		this.initServicePage();
		this.initMagnificPopup();
		this.initBlobResize();
		this.initInsightFilters();
		this.initContactAddressSwitcher();
		this.initProjectsVideos();
		this.initProjectsSingles();
		this.initGravityForms();
        this.initContactAdwordTracker();
		this.initSubscribeArticle();
		this.initPlayVideosOnScroll();
		this.initCOVIDAnnouncementModal();
		this.implementDeviceBasedFixes();
		this.initHomepageSroller();
		this.initServicesSubMenu();
	};

	App.prototype.initServicesSubMenu = function() {
	    var that = this;
        var $parentMenuItem = jQuery('.page-nav button.js-toggle-submenu');
        if ( ! $parentMenuItem.length ) return;
        $parentMenuItem.click(function(e) {
            e.preventDefault();
            var $wrapper = $parentMenuItem.closest('.menu-item-wrapper');
            $wrapper.toggleClass('open');
            if ( $wrapper.is('.open') ) {
                jQuery('nav.navigation.nav-initialised.open').addClass('has-submenu-opened');
            } else {
                jQuery('nav.navigation.nav-initialised.open').removeClass('has-submenu-opened');
            }
        });

    };

	App.prototype.destroy = function() {
		this.destroyMasonry();
		this.destroyHomepageSlider();
		this.destroyAboutSliders();
		this.destroyCultureSlider();
		this.destroyInsightSlider();
		this.destroyBlob();
		this.destroyServicesBlob();
		this.destroyServicesSection();
		// this.destroyServicesAnimation();
		this.destroyProjectSingles();
	}

	App.prototype.initSelectors = function() {
		this.$articles = jQuery('.content-hub .articles');
		this.$slider = jQuery('#content .home .slider .slider-inner').not(".slick-initialized");
		this.$mouse = jQuery('.home .slider .mouse').not(".slick-initialized");
		this.$aboutSlider = jQuery('#content .about-services .slider').not(".slick-initialized");
        this.$aboutHeadingSlider = jQuery('#content .about-header .slider .slider-inner').not(".slick-initialized");
		this.$cultureSlider = jQuery('#content .culture-header .slider .slider-inner').not(".slick-initialized");
		this.$insightSlider = jQuery('#content .insights-slider .slider').not(".slick-initialized");
		this.$insightCategoryFilter = jQuery('.insight-filter a.insight-category-filter');
		this.$insightLengthFilter = jQuery('.insight-filter a.insight-length-filter');
		this.$blob = jQuery('.home .blob-container').not('.blob-initialised');
		this.$servicesBlob = jQuery('.services-blob .blob-container').not('.blob-initialised');
		//this.$servicesSvg = jQuery('.services-blob svg').not('.initialised');
		this.$servicePage = jQuery('.service-header');
		this.$nav = jQuery('.navigation').not('.nav-initialised');
		this.$middleNav = jQuery(".middle-nav").not('.nav-initialised');
		this.$content = jQuery('#content');
		this.$websiteMockups = jQuery('.website-mockups-inner');
		this.$projectMosaics = jQuery('.mosaic-images-inner');
		this.$contentHubLoaderContainer = jQuery('#contentHub-loader-container');
		this.$gravityForms = jQuery('.gform_wrapper');
		this.$autoplayOnScrollMedias = jQuery(".js-autoplay-on-scroll");
		this.$projectMosaicsWithVideo = jQuery('.mosaic-images-inner--with-video');
		this.$categoryFilterType = jQuery('.insight-filter a.insight-category-filter').data('filter-type');
		this.$subCategoryFilter = '';
	}

    /*
        Global Variables
    */
    // @TODO: Bad code, move these to this.* scoping instead
    var categoryFilter="", minFilter="", maxFilter="", blobCanvas="", blobTriggerSlideNo="", blobAreaH="", blobAreaW="", contentHubLoader="", isLoading=false;

    App.prototype.initHomepageSroller = function() {
        // makes sure that the scroller is always on the video canvas.
        var $videoWrapper = jQuery('.home .video-bg-wrapper');
        var $scroller = $videoWrapper.find('.scrolldown-wrapper');
        if ( ! $videoWrapper.length || ! $scroller.length ) return;
        var $window = jQuery(window);

        var vwH = $videoWrapper.height();
        var sH = $scroller.height();

        if ( vwH < sH ) {
            $scroller.find('a').css({
                bottom: sH - vwH + 20 + 'px'
            });
        }

    }

    App.prototype.implementDeviceBasedFixes = function() {
        var isIOS = function() {
            return [
                'iPhone',
            ].includes(navigator.platform)
        }
        if ( isIOS() ) {
            console.log('iOS detected, implementing iOS fixes');

            const $body = jQuery('body');
            if ( ! $body.hasClass('ios-fixes') ) {
                $body.addClass('ios-fixes');
            }
            /**
             * @see https://stackoverflow.com/a/4847375/3531439
             */
            var style_rules = [];

            style_rules.push("body.ios-fixes .video-bg-wrapper .video-bg .scrolldown-wrapper { bottom: 150px; }");
            style_rules.push("body.ios-fixes .home .video-bg-wrapper .video-bg .slider-inner { margin-bottom: 150px; }");

            var style = '<!-- Appended CSS rules for iPhone users --><style type="text/css">' + style_rules.join("\n") + "</style><!-- Appended CSS rules for iPhone users ends. -->";
            jQuery("head").append(style);
        }
    }

    App.prototype.initAOS = function() {
    	// AOS = animate on scroll library
    	if (typeof(AOS) !== 'undefined') {
			AOS.init({ once:true });
		}
    }

    App.prototype.addBlacklistClass = function () {
		jQuery( 'a' ).each( function() {
			if ( this.href.indexOf('wp-admin') !== -1 ||
				this.href.indexOf('wp-login.php') !== -1 ) {
				jQuery( this ).addClass( 'wp-link' );
		}
	});
	}

	App.prototype.initPageTransitions = function () {
		if ( !this.$content ) return null;
		var that = this;

		that.addBlacklistClass();
		var settings = {
			anchors: 'a',
			blacklist: '.wp-link',
			debug: true,
			forms: 'form[data-nah-never-gonna-trigger]',
			// cacheLength: 5,
			onStart: {
				duration: that.animationDuration,
				render: function ( $container ) {

                    var $sidebarNav = jQuery('nav.navigation.nav-initialised');
                    var $sidebarNavToggle = jQuery('.nav-toggle');
                    if ($sidebarNav.length) {
                        $sidebarNav.get( 0 ).scrollTop = 0;
                        if ( $sidebarNav.hasClass('open') ) {
                            $sidebarNav.removeClass('open');
                        }
                        if ( $sidebarNavToggle.length && $sidebarNavToggle.hasClass('open') ) {
                            jQuery('.nav-toggle').removeClass('open');
                        }

                        var $openedChildMenus = jQuery('.page-nav .menu-item-wrapper.open')
                        if ( $openedChildMenus.length ) {
                            $openedChildMenus.removeClass('open');
                        }
                    }

					if (!$container.hasClass('no-animate'))
						$container.addClass( 'animate-out' );
				}
			},
			onReady: {
				duration: 0,
				// `$container` is a `jQuery Object` of the the current smoothState container
				// `$newContent` is a `jQuery Object` of the HTML that should replace the existing container's HTML.
				render: function ($container, $newContent) {
					// out with the old
					// debugger;
					app.destroy();
					// in with the new
					$container.html($newContent);
				}
			},
			onAfter: function( $container ) {

				app.init();
				that.addBlacklistClass();
				var $hash = jQuery( window.location.hash );

				if ( $hash.length !== 0 ) {
					var offsetTop = $hash.offset().top;
					jQuery( 'body, html' ).animate( {
						scrollTop: ( offsetTop - 60 ),
					}, {
						duration: that.animationDuration
					} );
				}

				if ($container.hasClass('animate-out'))
					$container.removeClass( 'animate-out' );

				if (window.location.pathname == '/') {
					// home page!
					jQuery('.homepage-only').removeClass('hide');
					jQuery('.page-name').addClass('hide');
					jQuery('nav.navigation.nav-initialised').removeClass('open');
					jQuery('.nav-toggle').removeClass('open');
				} else {
					// not home page
					jQuery('.homepage-only').addClass('hide');
					jQuery('.page-name').removeClass('hide');
					jQuery('.middle-nav.page-name li a').text($container.find('.page-name').text());
				}

				// if they are going to the services page
                var $sidenav = jQuery('nav.navigation.nav-initialised');
				if ( window.location.pathname.startsWith('/services/') ) {
				    // add "has-submenu-opened" class on the sidenav
                    if ( $sidenav.length ) {
                        $sidenav.addClass('has-submenu-opened');
                    }
                    // make .jsa-menu-services opened
                    var $servicesMenuItem = jQuery('.jsa-menu-services');
                    var $servicesMenuItemWrapper = $servicesMenuItem.closest('.menu-item-wrapper');
                    if ( $servicesMenuItem.length && $servicesMenuItemWrapper.length ) {
                        $servicesMenuItemWrapper.addClass('open');
                    }
                } else {
				    // close all opened submenus
                    var $openedChildMenus = jQuery('.page-nav .menu-item-wrapper.open')
                    if ( $openedChildMenus.length ) {
                        $openedChildMenus.removeClass('open');
                    }
                    // remove "has-submenu-opened" class on the sidenav
                    if ( $sidenav.length ) {
                        jQuery('nav.navigation.has-submenu-opened.nav-initialised').removeClass('has-submenu-opened');
                    }
                }

				if (typeof ga !== "undefined") {
					ga('set', 'page', window.location.pathname);
					ga('send', 'pageview');
				}
			}
		};

		var smoothState = that.$content.smoothState( settings ).data('smoothState');
		that.$smoothState = smoothState;
	}

    /**
	 * masonry
	 */
	App.prototype.initMasonry = function() {
		if ( !this.$articles || this.$articles.length <= 0) return null;
		var that = this;

		// this.$articles.find('.article').append('<div class="curtain"></div>');

		that.$articles.removeClass('invisible');
		that.$articles.find('.curtain').removeClass('invisible');

		// that.$articles.find('.article').addClass('animate');
		// setTimeout(function(){
		// 	that.$articles.find('.animate').removeClass('animate');
		// }, 1500);

		this.$masonry = this.$articles.masonry({
			// set itemSelector so .grid-sizer is not used in layout
			itemSelector: '.article',
			// use element for option
			columnWidth: '.article-sizer',
			stamp: '.article-stamp',
			percentPosition: true,
			// gutter: 55,
			transitionDuration: 0,
			// stagger: 300 //ms
			horizontalOrder: true
		});

		this.$masonry.imagesLoaded().progress( function() {
			that.$masonry.masonry('layout');
		});

		this.$width = jQuery('.articles').width();
		jQuery(window).resize(function() {
			that.$width = jQuery('.articles').width();
		});

		this.ajaxLoadMore = this.$articles.data('ajax-load-more');

		if (this.ajaxLoadMore && this.ajaxLoadMore == true) {
			// var loadPoint = that.$articles.outerHeight() + that.$articles.offset().top;
		 	var maxPages = 99;
		 	var isSubmitting = false;

		 	var numberPerPage = that.$articles.data("number-per-page");
		 	var cat = that.$articles.data("cat");

		 }

		const columnRegex = /column-(\d)/g;
		this.$masonry.on( 'layoutComplete', function(event, laidOutItems){
			var didAnythingChange = false;
			for (var i = 0; i < laidOutItems.length; i++) {
				var element = jQuery(laidOutItems[i].element);

				var oldColumn = element.attr('class').match(columnRegex);

				var position = element.position();
				var columnPercentage = (position.left / that.$width);
				var column = (Math.round(columnPercentage * 100) / 100);
				column = column * 10 / 3;
				column = Math.round(column + 1);

				var newColumn = 'column-'+column;
				if (column <= 3) {
					if (oldColumn && newColumn !== oldColumn.join(' ')) {
						element.removeClass(oldColumn.join(' '));
						didAnythingChange = true;
					}
					element.addClass(newColumn);
				} else {
					console.error('Column calculation bugged out!');
				}
			}
			if (didAnythingChange === true) {
				that.$masonry.masonry('layout');
				didAnythingChange = false;
			}

			if (typeof(AOS) !== 'undefined') {
				AOS.refresh();
			}

		});

        jQuery(document).ready(function() {
            that.$masonry.masonry('layout');
        });

		jQuery(window).scroll(function(){
			var page = Math.ceil(jQuery('.article:not(.article-subscribe)', that.$articles).length / numberPerPage) + 1;
			if (!that.ajaxLoadMore || that.ajaxLoadMore !== true || page > maxPages || isSubmitting == true) {
				return false;
			}

			isSubmitting = true;

            // Show Loader
            contentHubLoader = jQuery('<hr class="vertical"></div>');
            that.$contentHubLoaderContainer.append(contentHubLoader);
            isLoading = true;
            that.ContentHubShowLoader();

            var getExistingArticlePostIds = function() {
                var postIds = [];
                that.$articles.find('article.article').each(function(index, el) {
                    postIds.push(jQuery(el).data('post-id'));
                });
                return postIds;
            }

			jQuery.ajax({
				async: false,
				url: '/wp/wp-admin/admin-ajax.php',
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'ajax_pagination',
					paged: page,
					cat: cat,
                    posts_per_page: numberPerPage,
				}
			}).done(function(data) {

				var $content = jQuery( data['html'] );
				maxPages = data['max'];
				var existing = getExistingArticlePostIds();

                $content = $content.filter(function (i, el) {
                    return (jQuery(el).is('article.article') && existing.indexOf(Number(jQuery(el).data('post-id'))) === -1);
                });

				that.$masonry.append($content).imagesLoaded().progress( function() {
					that.$masonry.masonry('layout');
				});
				that.$masonry.append($content).masonry('appended', $content);

				switch ( that.$categoryFilterType ) {
					case 'subcategory':
						that.subcategoryFilterChange(categoryFilter, that.$subCategoryFilter);
						break;
					default:
						that.filterChange(categoryFilter,minFilter,maxFilter);
				}

				isSubmitting = false;

                // Hide Loader
                isLoading = false;

			})
			.fail(function(data) {
				console.error("AJAX failed:", data);
			});
		});
	};

	App.prototype.destroyMasonry = function () {
		if ( !this.$masonry ) return null;

		this.$masonry.masonry('destroy');
	}

	App.prototype.initMainNav = function() {
		if ( !this.$nav || this.$nav.length <= 0 ) return null;
		var that = this;

		jQuery(".nav-toggle").click(function(e){
			e.preventDefault();

			jQuery(this).toggleClass("open");
			that.$nav.toggleClass("open");
		});

        // clicking anywhere in the document
        jQuery(document).click(function(e){
            // where navigation is open
            if (jQuery(".nav-toggle").hasClass( "open" ) == true) {
                // except clicking inside the navigation div
                if( jQuery(e.target).closest(".navigation").length > 0 ) {
                    return false;
                }
                // will close the said navigation
                setTimeout(function(){
                    that.$nav.removeClass("open");
                    jQuery(".nav-toggle").removeClass("open");
                    location.href = anchor.href;
                }, 250);
            }
        });

		jQuery(".page-nav a").on('mousedown touchstart', function () {
			var href = jQuery(this).attr('href');
			that.$smoothState.fetch(href);
		}).on('click', function(e){
			// e.preventDefault();
			var anchor = this;

			jQuery(".current-menu-item").removeClass('current-menu-item');
			jQuery(anchor).addClass('current-menu-item');

			if (that.$smoothState) {
				that.$smoothState.load(anchor.href);
			}

			setTimeout(function(){
				that.$nav.removeClass("open");
				jQuery(".nav-toggle").removeClass("open");
				if (!that.$smoothState) {
					location.href = anchor.href;
				}
			}, 250);
			return false;
		});

		jQuery(".navigation .logo").on('mousedown touchstart', function () {
			var href = jQuery(this).attr('href');
			if (that.$smoothState) {
				that.$smoothState.fetch(href);
			}
		}).on('click', function(e){
			e.preventDefault();
			var anchor = this;

			jQuery(".current-menu-item").removeClass('current-menu-item');
			// jQuery(".page-nav a:first-child").addClass('current-menu-item'); // assuming home page will always be the first menu item

			if (that.$smoothState) {
				that.$smoothState.load(anchor.href);
			} else {
				location.href = anchor.href;
			}
			// return false;
		});

		jQuery(".page-nav").hover(function(e){
			jQuery(".current-menu-item").addClass("no-line");
		}, function(e){
			jQuery(".current-menu-item").removeClass("no-line");
		});

		that.$nav.addClass('nav-initialised');
	};

	App.prototype.initMiddleNav = function() {
		if ( !this.$middleNav || this.$middleNav.length <= 0 ) return null;

		// adapted from https://jsfiddle.net/mekwall/up4nu/

		// Cache selectors
		var lastId,
		topMenu = this.$middleNav,
		// All list items
		menuItems = topMenu.find("a"),
		// Anchors corresponding to menu items
		scrollItems = menuItems.map(function(){
			var item = jQuery(jQuery(this).attr("href"));
			if (item.length) { return item; }
		});

		// Bind click handler to menu items
		// so we can get a fancy scroll animation
		jQuery('a[href*="#"]:not([href="#"])').click(function(e){
			var href = jQuery(this).attr("href"),
			offsetTop = href === "#" ? 0 : jQuery(href).offset().top;
			jQuery('html, body').stop().animate({
				scrollTop: offsetTop
			}, 300);
			e.preventDefault();
		});

		function calcActiveClass() {

			// Get container scroll position
			var fromTop = jQuery(this).scrollTop();

			// Get id of current scroll item
			var cur = scrollItems.map(function(){
			if (jQuery(this).offset().top <= fromTop)
				return this;
			});

            // check if at the bottom of the page
            if( Math.abs(jQuery(window).scrollTop() + jQuery(window).height() - jQuery(document).height()) < 200) {
               //alert("bottom!");
                menuItems
                .parent().removeClass("active");
			     cur = cur[cur.length-1];
            }

			// Get the id of the current element
			cur = cur[cur.length-1];
			var id = cur && cur.length ? cur[0].id : "";

			if (lastId !== id) {
				lastId = id;
				// Set/remove active class
				menuItems
				.parent().removeClass("active")
				.end().filter("[href='#"+id+"']").parent().addClass("active");
			}
		}

		// Bind to scroll
		jQuery(window).scroll(calcActiveClass);
		jQuery(document).ready(calcActiveClass);
	};

	App.prototype.initHomepageSlider = function() {
		if ( !this.$slider || this.$slider.length <= 0 ) return null;
		var that = this;

		console.log('calling initHomepageSlider');

		var autoPlayTime = 5000, current = 1;
		// var triggerAnimationTime = autoPlayTime - 500;
		var slickSlider = this.$slider.slick({
			dots: false,
			arrows: false,
			fade: true,
			draggable: false,
			// accessibility: false,
			autoplay: true,
			autoplaySpeed: autoPlayTime,
			pauseOnFocus: false,
			pauseOnHover: false
		});

		// kickstart the animations on the first slide
		// setTimeout(function(){
		// 	// in
		// 	that.$slider.find(".slide:first").addClass("animation-active");
		// }, 1000);
		// setTimeout(function(){
		// 	// out
		// 	that.$slider.find(".slide:first").removeClass("animation-active");
		// }, triggerAnimationTime);

		jQuery(".middle-nav.homepage-only li.slides:first-child").addClass('slide-active');

		jQuery('.slides a[data-slide]').on('click', function(){
            // save the cause of trigger to our global variable
            blobTriggerSlideNo = jQuery(this);
			var slideNo = jQuery(this).data('slide');
			slickSlider.slick('slickGoTo', slideNo);
		});

		that.$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// console.log('homepage beforeChange triggered');

			jQuery("li.slide-active").removeClass('slide-active');
			$new = jQuery('.slides').find("a[data-slide='" + nextSlide + "']");
			$new.parent().addClass('slide-active');

			if (typeof(that.$blobCanvas) !== 'undefined') {
				// console.log('homepage beforeChange: blobCanvas is defined');

				var color = $new.data('color');
				that.$blobCanvas.changeColor(color);
				that.$mouse.attr('class', 'mouse color-'+color);
			}
		});


		var splitText = [];
		if (splitText[0] === undefined) {
			var heading = that.$slider.find(".slide:first h2");
			heading.addClass("split-text-active");
			//splitText[0] = new SplitText(heading);
		}

		that.$slider.on('afterChange', function(event, slick, currentSlide) {
			// console.log('homepage afterChange triggered');

			current = currentSlide;
			// that.$slider.find(".slide:eq("+currentSlide+")").addClass("animation-active");

			// setTimeout(function(){
			// 	that.$slider.find(".slide:eq("+current+")").removeClass("animation-active");
			// }, triggerAnimationTime);

			if (splitText[currentSlide] === undefined) {
				var heading = that.$slider.find(".slide:eq("+currentSlide+") h2");
				heading.addClass("split-text-active");
				//splitText[currentSlide] = new SplitText(heading);
			}

		});

		// jQuery('.homepage-only').removeClass('hide');
		// jQuery('.page-name').addClass('hide');

	}

	App.prototype.destroyHomepageSlider = function() {
		if ( !this.$slider || this.$slider.length <= 0 ) return null;

		this.$slider.slick('unslick');
		this.$slider.off('beforeChange');
		this.$slider.off('afterChange');
		this.$slider.unbind();

		jQuery('.slides a[data-slide]').off('click');

		delete this.$slider;

		jQuery("li.slide-active").removeClass('slide-active');

		// console.log("destroyHomepageSlider called");

		// jQuery('.homepage-only').addClass('hide');
		// jQuery('.page-name').removeClass('hide');

		// @TODO: should we destroy the event listeners?
	}

	App.prototype.initAboutSliders = function() {
		if ( !this.$aboutHeadingSlider || this.$aboutHeadingSlider.length <= 0 ) return null;
		var that = this;

		// About Heading slider
		that.$aboutHeadingSlider.slick({
			dots: false,
			arrows: false,
			fade: true,
			draggable: false,
			// accessibility: false,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnFocus: false,
			pauseOnHover: false
		});

	}

	App.prototype.destroyAboutSliders = function() {
		if ( !this.$aboutHeadingSlider || this.$aboutHeadingSlider.length <= 0 ) return null;

		this.$aboutHeadingSlider.slick('unslick');

		// @TODO: should we destroy the event listeners?
	}

	App.prototype.initCultureSlider = function() {
		if ( !this.$cultureSlider || this.$cultureSlider.length <= 0) return null;
		var that = this;

		that.$cultureSlider.slick({
			dots: false,
			arrows: false,
			fade: true,
			draggable: false,
			// accessibility: false,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnFocus: false,
			pauseOnHover: false
		});
	}

	App.prototype.destroyCultureSlider = function() {
		if ( !this.$cultureSlider || this.$cultureSlider.length <= 0) { return null; }
		this.$cultureSlider.slick('unslick');
		// @TODO: should we destroy the event listeners?
	}

    App.prototype.ContentHubShowLoader = function () {
        // var that = this;
        var tid = setInterval(checkIfLoading, 1000);
        function checkIfLoading() {
            if (isLoading == true) {
                contentHubLoader.toggleClass("active");
            } else {
                contentHubLoader.removeClass("active");
                contentHubLoader.remove();
                clearInterval(tid);
            }
        }
    }

	App.prototype.initInsightSlider = function() {
		if ( !this.$insightSlider || this.$insightSlider.length <= 0 ) { return null; }
		var that = this;

		var $prevArrow = jQuery(".slider-nav .prev-arrow");
		var $nextArrow = jQuery(".slider-nav .next-arrow");

		that.$insightSlider.slick({
			dots: false,
			arrows: true,
			fade: true,
			draggable: false,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnFocus: false,
			prevArrow: $prevArrow,
			nextArrow: $nextArrow,
		});
	};

	App.prototype.destroyInsightSlider = function() {
		if ( !this.$insightSlider || this.$insightSlider.length <= 0 ) { return null; }

		this.$insightSlider.slick('unslick');
	};

	App.prototype.initBlob = function() {
		// If services blob is true don't do this
		if ( this.$servicesBlob && this.$servicesBlob.length > 0 ) { return null; }
		if ( !this.$blob || this.$blob.length <= 0 ) { return null; }
		var that = this;

		this.$blobCanvas = new site.blobCanvas(that.$blob, {});
        blobAreaW = jQuery(window).width();
        blobAreaH = jQuery(window).height();

        this.$blob.addClass('blob-initialised');
	};

	App.prototype.destroyBlob = function() {
		if ( !this.$blob || this.$blob.length <= 0 ) { return null; }
		this.$blobCanvas.rendererStop();
		this.$blob.find("canvas").remove();
		delete this.$blobCanvas;
	};

	App.prototype.initServicesBlob = function() {
		if ( !this.$servicesBlob || this.$servicesBlob.length <= 0 ) { return null; }
		var that = this;

		this.$servicesBlobCanvas = new site.blobCanvasServices(that.$servicesBlob, {
			links: jQuery('.blob-links a', that.$servicesBlob)
		});
        blobAreaW = jQuery(window).width();
        blobAreaH = jQuery(window).height();
        this.$servicesBlob.addClass('blob-initialised');
	};

	App.prototype.destroyServicesBlob = function() {
		if ( !this.$servicesBlob || this.$servicesBlob.length <= 0 ) { return null; }
		this.$servicesBlobCanvas.rendererStop();
		this.$servicesBlob.find("canvas").remove();
		delete this.$servicesBlobCanvas;
	};

	App.prototype.initServicesSection = function() {
		// if ( (!this.$servicesSvg || this.$servicesSvg.length <= 0) && (!this.$servicePage || this.$servicePage.length <= 0) ) { return null; }
		if ( !this.$servicesSvg || this.$servicesSvg.length <= 0 ) { return null; }
		jQuery("#content").addClass("no-animate");
	};

	App.prototype.destroyServicesSection = function() {
		// if ( (!this.$servicesSvg || this.$servicesSvg.length <= 0) && (!this.$servicePage || this.$servicePage.length <= 0) ) { return null; }
		if ( !this.$servicesSvg || this.$servicesSvg.length <= 0 ) { return null; }
		jQuery("#content").removeClass("no-animate");
	};
/*
	App.prototype.initServicesAnimation = function() {
		if ( !this.$servicesSvg || this.$servicesSvg.length <= 0 ) { return null; }
		var that = this;

		function animateBlobHover(el, translateY, duration, elasticity, hoverOn) {
			anime.remove(el);

			var settings = {
				targets: el,
				translateY: translateY,
				duration: duration,
				elasticity: elasticity
			};

			// if (hoverOn == true) {
			// 	settings.rotate = { value: 360, duration: 120000, easing: 'linear'};
			// 	settings.scaleY = {value: 1.25, duration: 60000, easing: 'linear', direction: 'alternate'};
			// 	settings.loop = true;
			// 	// settings.direction = 'alternate';
			// } else {
			// 	settings.rotate = {value: 0, duration: duration};
			// 	settings.scaleY = {value: 1, duration: duration};
			// }

			anime(settings);
		};

		function animateBlobClick(el, i) {
			var pos = el.getBBox();
			var scale = 4 + i;
			var x = pos.x + (pos.width / 2) - 10;  // 10px offset
			var y = pos.y + (pos.height / 2);

			var settings = {
				targets: el,
				translateY: -Math.abs(y),
				scale: scale,
				duration: that.animationDuration
			};

			anime.remove(el);
			anime(settings);

			var color = jQuery(".blob-links a").eq(i).data('color');
			anime({
				targets: document.querySelector(".services-main"),
				backgroundColor: [
					{ value: color }
				],
				duration: that.animationDuration
			});

			jQuery('html, body').stop().animate({
				scrollTop: 0
			}, 150);
		};

		function animateBlobTextHover(el, translateY, duration, elasticity) {
			anime.remove(el);
			anime({
				targets: el,
				translateY: translateY,
				duration: duration,
				elasticity: elasticity
			});
		};

		function animateBlobTextClick(el, i) {
			var pos = el.getBBox();
			var y = (2 * pos.y) - 150;
			var x = pos.x + (pos.width / 2);
			anime.remove(el);

			var settings = {
				targets: el,
				translateX: "-"+Math.abs(x)+"px",
				translateY: "-"+Math.abs(y)+"px",
				scale: 2,
				duration: that.animationDuration
			};

			anime.remove(el);
			anime(settings);
		}

		function servicesHoverOn(target, i) {
			// el, translateY, duration, elasticity, hoverOn
			animateBlobHover(target, -25, 800, 0, true);
			var text = document.querySelector('.services-blob svg g.w'+(i+1));
			animateBlobTextHover(text, -25, 800, 0);
		}

		function servicesHoverOff(target, i) {
			// el, translateY, duration, elasticity, hoverOn
			animateBlobHover(target, 0, 300, 0, false);
			var text = document.querySelector('.services-blob svg g.w'+(i+1));
			animateBlobTextHover(text, 0, 300, 0);
		}

		function servicesClick(target, i) {
			animateBlobClick(target, i);
			var text = document.querySelector('.services-blob svg g.w'+(i+1));
			animateBlobTextClick(text, i);

			jQuery(".services-header").fadeOut(150);

			// click triggered here
			jQuery(".blob-links a").eq(i).click();

			jQuery(".services-blob svg path.st").not(jQuery(target)).fadeOut(150);
			jQuery(".services-blob svg g.w").not(jQuery(text)).fadeOut(150);
			jQuery(text).delay(that.animationDuration - 150).fadeOut(150);
		}

		var serviceBlobs = document.querySelectorAll('.services-blob svg path.st');
		var allowMouseEnters = [];
		var allowMouseLeaves = [];

		for (var i = 0; i < serviceBlobs.length; i++) {
			allowMouseEnters[i] = true;
			allowMouseLeaves[i] = true;

			serviceBlobs[i].addEventListener('mouseenter', function(e) {
				var index = [].indexOf.call(serviceBlobs, e.target);

				if (allowMouseEnters[index] == true) {
					servicesHoverOn(e.target, index);
				}
			}, false);

			serviceBlobs[i].addEventListener('mouseleave', function(e) {
				var index = [].indexOf.call(serviceBlobs, e.target);

				if (allowMouseLeaves[index] == true) {
					servicesHoverOff(e.target, index);
				}
			}, false);

			serviceBlobs[i].addEventListener('click', function(e) {
				var index = [].indexOf.call(serviceBlobs, e.target);
				allowMouseEnters[index] = false;
				allowMouseLeaves[index] = false;

				servicesClick(e.target, index);
			});
		}

		// effect on load
		anime({
			targets: serviceBlobs,
			translateY: [1000, 0],
			scaleX: [2, 1],
			duration: 1000,
			elasticity: 0,
			delay: function(el, i, l) {
				return 100 + (i * 100);
			}
		});

		// text effect on load
		anime({
			targets: document.querySelectorAll(".services-blob svg g.w"),
			opacity: [0, 1],
			duration: 1000,
			elasticity: 0,
			delay: function(el, i, l) {
				return 100 + (i * 100);
			}
		});
	}
*/

	App.prototype.destroyServicesAnimation = function() {
		if ( !this.$servicesSvg || this.$servicesSvg.length <= 0 ) { return null; }

		jQuery("#content").removeClass("no-animate");
	};

	App.prototype.initServicePage = function() {
		if ( !this.$servicePage || this.$servicePage.length <= 0 ) { return null; }
		var that = this;

		// normal effects

		var headerTop = document.querySelector(".header-top");
		var headerHeight = jQuery(headerTop).css({height:'auto'}).outerHeight();
		var refreshedAOS = false;
		anime({
			targets: headerTop,
			height: [
				{ value: "+=2000px", duration: 0 },
				{ value: headerHeight, duration: 4000, delay: 150 }
			],
			elasticity: 0,
			update: function(anim) {
				if (Math.round(anim.progress) > 50 && refreshedAOS === false && typeof(AOS) !== 'undefined') {
					AOS.refresh();
					refreshedAOS = true;
				}
			}
		});

		anime({
			targets: document.querySelector(".service-header"),
			backgroundColor: "#FFFFFF",
			//height: '0',
			duration: 300
		});

		// jQuery(".service-header .mouse").css({opacity: 0}).delay(4150).animate({opacity: 1}, 300);

		// Animate bottom of header wave
		anime({
			targets: document.querySelector(".header-bottom svg path"),
			scaleX: [
				{ value: 2 },
				{ value: 1 },
				{ value: 2 },
			],
			translateX: [
				{ value: "-300px" },
				{ value: 0 },
				{ value: "300px" },
			],
			direction: 'alternate',
			easing: 'linear',
			duration: 50000,
			loop: true
		});

		// special sections

        that.timeline = anime.timeline()
		if (jQuery(".seo-sem").length > 0 && that.timeline) {

			that.timeline.add({
				targets: '.seo-sem polyline',
				easing: 'easeInOutSine',
				duration: 1000,
				offset: 500,
				strokeDashoffset: [anime.setDashoffset, 0],
				autoplay: false
			}).add({
				targets: '.seo-sem .search',
				easing: 'easeInOutSine',
				duration: 1000,
				offset: 500,
				strokeDashoffset: [anime.setDashoffset, 0],
				autoplay: false
			}).add({
				targets: '.seo-sem .graph',
				easing: 'easeInOutSine',
				duration: 1000,
				offset: 500,
				transformOrigin: ['bottom center'],
				height: function(target) {
					return [0, target.getAttribute('height')];
				},
				translateY: function(target) {
					return [target.getAttribute('height'), 0];
				},
				delay: function(el, i) { return i * 50 },
				autoplay: false
			}).add({
				targets: '.seo-sem g',
				duration: 1000,
				offset: 500,
				opacity: [0, 1],
				delay: function(el, i) { return i * 70 },
				elasticity: 0,
				autoplay: false
			});

			// document.querySelector('.seo-sem').onclick = that.timeline.restart;

			var triggeredSeoAnimation = false;
			jQuery(window).scroll(function() {
				if (jQuery('.seo-sem-outer').hasClass("aos-animate")) {
					if (triggeredSeoAnimation == false) {
						that.timeline.restart();
						triggeredSeoAnimation = true;
					}
				} else {
					triggeredSeoAnimation = false;
				}
			});

		}
	}

	App.prototype.initMagnificPopup = function() {
		jQuery('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
			disableOn: 700,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,

			fixedContentPos: false
		});
	}

    App.prototype.initBlobResize = function() {
		if ( !this.$blob || this.$blob.length <= 0 ) { return null; }
		var that = this;
        // this function triggers when there's already
        // existing blob object in our page
        // and if the page got resize, we must renew
        // the blob so it adapts the new window size
        jQuery(window).resize(function() {
          //resize just happened, pixels changed
            // new blob area
            var newBlobAreaW = jQuery(window).width();
            var newBlobAreaH = jQuery(window).height();
            //console.log("newBlobArea "+newBlobArea);

                /*console.log("newBlobArea "+newBlobArea);
                console.log("blobArea "+blobArea);
                console.log(Math.abs(newBlobArea - blobArea));*/
            if (that.$blobCanvas != "" && (Math.abs(newBlobAreaH - blobAreaH) > 180 || Math.abs(newBlobAreaW - blobAreaW) > 180)) {
                // remove the current blob
				that.$blobCanvas.rendererStop();
                that.$blob.find("canvas").remove();
                // create a new blob
                that.initBlob();
                //console.log("blob resize triggered!");
                // check if user has already clicked a slide
                if (blobTriggerSlideNo != "") {
                    jQuery("li.slide-active").removeClass('slide-active');
                    var slideNo = blobTriggerSlideNo.data('slide');
                    that.$slider.slick('slickGoTo', slideNo);
                    blobTriggerSlideNo.parent().addClass('slide-active');

                    if (typeof(that.$blobCanvas) !== 'undefined') {
                        var color = blobTriggerSlideNo.data('color');
                        that.$blobCanvas.changeColor(color);
                        that.$mouse.attr('class', 'mouse color-'+color);
                    }
                }

            }
        });
    }

    App.prototype.initInsightFilters = function() {
		var that = this;

        if (this.$insightCategoryFilter) {
            that.$insightCategoryFilter.click(function(){
                that.$insightCategoryFilter.removeClass("active");
				categoryFilter = jQuery(this).data('value');
				switch( that.$categoryFilterType ) {
					case 'subcategory':
						that.$subCategoryFilter = jQuery(this).data('project-filter');
						that.subcategoryFilterChange(categoryFilter, that.$subCategoryFilter);
						break;
					default:
						that.filterChange(categoryFilter,minFilter,maxFilter);
				}
                jQuery(this).addClass("active");
                return false;
            });
        }

        if (this.$insightLengthFilter) {
            that.$insightLengthFilter.click(function(){
                if (jQuery(this).hasClass("active")) {
                    minFilter = "";
                    maxFilter = "";
                    that.$insightLengthFilter.removeClass("active");
                    that.filterChange(categoryFilter,minFilter,maxFilter);
                    return false;
                } else {
                    that.$insightLengthFilter.removeClass("active");
                    jQuery(this).addClass("active");
                    minFilter = jQuery(this).data('min');
                    maxFilter = jQuery(this).data('max');
                    that.filterChange(categoryFilter,minFilter,maxFilter);
                    return false;
                }
            });
        }
	}
	
	App.prototype.subcategoryFilterChange = function(categoryFilter, subcategory) {
		if ( !this.$insightCategoryFilter || this.$insightCategoryFilter.length <= 0 ) return null;
		var that = this;

		// that.$articles.find('.article-' + categoryFilter).not('.article-subscribe').hide();
		that.$articles.find('.article-' + categoryFilter).not('.article-subscribe').each( function() { jQuery(this).hide(); } );

		if (subcategory !== "") {
			that.$articles.find('.article-' + categoryFilter).each( function() {
				var currentArticle = jQuery(this);
				var subCats = currentArticle.data('project-category').split(',');
				// console.log('current', currentArticle);
				// console.log('subcats', subCats);
				// console.log('looking for', subcategory);
				// console.log('index', subCats.indexOf(subcategory));
				if ( subCats.indexOf(subcategory) > -1 ) {
					currentArticle.show();
				}
			});
		} else {
			that.$articles.find('.article').show();
		}
		if (that.$masonry) {
			console.log('recalculating');
			that.$masonry.masonry('layout');
		}
	}

	App.prototype.filterChange = function(categoryFilter, minFilter, maxFilter) {
		if ( !this.$insightCategoryFilter || this.$insightCategoryFilter.length <= 0 ) return null;
		var that = this;

		that.$articles.find('.article').not('.article-subscribe').hide();
		if (categoryFilter !== "" && minFilter !== "" && maxFilter !== "") {
            for (var i = minFilter; i <= maxFilter; i++) {
                that.$articles.find('.article-' + categoryFilter + '[data-reading="'+ i +'"]').each(function() {
                    jQuery(this).show();
                });
            }
		}
        else if (categoryFilter !== "" && minFilter == "" && maxFilter == "") {
            that.$articles.find('.article-' + categoryFilter).each(function() {
                jQuery(this).show();
            });
        }
        else if (categoryFilter == "" && minFilter != "" && maxFilter != "") {
            for (var i = minFilter; i <= maxFilter; i++) {
                that.$articles.find('[data-reading="'+ i +'"]').each(function() {
                    jQuery(this).show();
                });
            }
        } else {
            that.$articles.find('.article').show();
        }

		if (that.$masonry) {
			that.$masonry.masonry('layout');
		}
	}

	App.prototype.initContactAddressSwitcher = function() {
		jQuery(function($) {

            var $links, $switcher;

            // Get the links and the container
            $links = $('[data-show]');
            $switcher = $('.js-switch');
            var $prev = $links.first();

            // Show only the first div
            $switcher.children().not(':first').fadeOut(500);
            $links.not(':first').addClass("inactive");
            $links.first().addClass("active");
            //$links.first().find(".region-bar").addClass("current");

            // When a link is clicked
            $links.click(function() {

                if ($prev != "") {
                    $prev.removeClass("active");
                    $prev.addClass("inactive");
                    //$prev.find(".region-bar").removeClass("current");
                }
                $prev = $(this);
                //$(this).find(".region-bar").addClass("current");
                $prev.addClass("active");
                $prev.removeClass("inactive");

                var id;

                // Get the ID of the div to show
                id = '[data-switch="' + $(this).data('show') + '"]';

                // Show the div
                $switcher.children(id).fadeIn(500);

                // Hide the other divs
                $switcher.children().not(id).hide();
            });


            /*$links.hover(function(e){
                $(this).find(".region-bar").addClass("current");
            }, function(e){
                if ($(this).hasClass("inactive")) {
                    $(this).find(".region-bar").removeClass("current");
                }
            });*/

        });
	}

	App.prototype.initProjectsVideos = function() {
		// @TODO: refactor this to use Magnific Popup
		function popUpVideo() {
            var $current = jQuery(this);
            var $container = $current.find(".video-overlay-container");
            var $video = $container.data("video-html");
            $container.html($video);
        }

        jQuery('.popup-video').on( "click", popUpVideo );
	}

	App.prototype.initProjectsSingles = function() {
		if ( !this.$websiteMockups && !this.$projectMosaics && !this.$projectMosaicsWithVideo ) return null;
		var that = this;

		if (this.$websiteMockups.length > 0) {
			this.$mockupsMasonry = this.$websiteMockups.masonry({
				gutter: 60,
				transitionDuration: 0,
				// stagger: 300 //ms
				horizontalOrder: true
			});

			this.$mockupsMasonry.imagesLoaded().progress( function() {
				that.$mockupsMasonry.masonry('layout');
			});
		}

		if (this.$projectMosaics.length > 0) {
			this.$mosaicsMasonry = this.$projectMosaics.masonry({
				gutter: 24,
				transitionDuration: 0,
				// stagger: 300 //ms
				horizontalOrder: true,
				fitWidth: true,
				columnWidth: '.grid-sizer',
				// do not use .grid-sizer in layout
				itemSelector: '.grid-item',
			});

			this.$mosaicsMasonry.imagesLoaded().progress( function() {
				that.$mosaicsMasonry.masonry('layout');
			});
		}


		if (this.$projectMosaicsWithVideo.length > 0) {
			this.$mosaicsVideoMasonry = this.$projectMosaicsWithVideo.masonry({
				transitionDuration: 0,
				gutter: 48,
				// stagger: 300 //ms
				fitWidth: false,
				columnWidth: '.grid-sizer',
				// do not use .grid-sizer in layout
				itemSelector: '.grid-item',
				horizontalOrder: true,
			});

			this.$mosaicsVideoMasonry.imagesLoaded().progress( function() {
				that.$mosaicsVideoMasonry.masonry('layout');
			});
		}

	}

	App.prototype.destroyProjectSingles = function() {
		if ( !this.$websiteMockups && !this.$projectMosaics && !this.$projectMosaicsWithVideo ) return null;

		this.$websiteMockups.masonry('destroy');
		this.$projectMosaics.masonry('destroy');
		this.$projectMosaicsWithVideo.masonry('destroy');
	}

	App.prototype.initGravityForms = function() {
		if ( !this.$gravityForms || this.$gravityForms.length <= 0 || !this.$smoothState ) return null;

		// Thanks to poorly-coded Gravity Forms, gotta retrigger DOMContentLoaded

		if(document.createEvent){
			var evt = document.createEvent("MutationEvents");
			evt.initMutationEvent("DOMContentLoaded", true, true, document, "", "", "", 0);
			document.dispatchEvent(evt);
		}
	}


    App.prototype.initContactAdwordTracker = function() {
        jQuery(function($) {
            $(".contact-adword-tracker").click(function(){
                return false;
            });
        });
    }




	// Subscribe Article - Content Hub
	App.prototype.initSubscribeArticle = function() {
		var that = this;

		jQuery('.subscribe-error, .subscribe-success').hide();

        jQuery('#subscribe-form').on('submit', function (e) {
            e.preventDefault();

			jQuery(this).slideUp();

            jQuery.getJSON(
            this.action + "?callback=?",
            jQuery(this).serialize(),
            function (data) {
				if (data.Status === 200) {
					// jQuery('.subscribe-success p').text(data.Message);
					jQuery('.subscribe-success').slideDown();
                } else { // not 200
					jQuery('.subscribe-error').slideDown();
				}
            });
        });

		jQuery('.subscribe-retry').on('click', function (e) {
			e.preventDefault();
			jQuery('.subscribe-error, .subscribe-success').slideUp();
			jQuery('#subscribe-form').slideDown();
		});
	}

	App.prototype.initPlayVideosOnScroll = function() {
		if (!this.$autoplayOnScrollMedias.length) {
			console.log('no autoplayVideosOnScroll to observe.');
			return;
		}
		var medias = this.$autoplayOnScrollMedias;
		var checkIfVideoShouldPlay = function() {
			console.log('running checkIfVideoShouldPlay.');
			var that = this;
			var tolerancePixel = 40;
			// Get current browser top and bottom
			var scrollTop = jQuery(window).scrollTop() + tolerancePixel;
			var scrollBottom = jQuery(window).scrollTop() + jQuery(window).height() - tolerancePixel;
	
			medias.each(function(index, el) {
				var yTopMedia = jQuery(this).offset().top;
				var yBottomMedia = jQuery(this).height() + yTopMedia;
	
				if(scrollTop < yBottomMedia && scrollBottom > yTopMedia){
					console.log('autoplaying: ', jQuery(this).get(0));
					jQuery(this).get(0).play();
				}
			});
		}
		jQuery(document).on('scroll', checkIfVideoShouldPlay);
	}

	App.prototype.initCOVIDAnnouncementModal = function() {
		jQuery(document).ready(function($) {

		    const $modal = jQuery("#covid-19-announcement");
		    const cookieName = "jsa_covid_announcement_closed";

		    if ( 0 === $modal.length ) return;

		    const hasRead = Boolean($.cookie(cookieName));
            console.log('covid-19 announcement has been read?', hasRead);

            $modal.on("hidden.bs.modal", function () {
                $.cookie(cookieName, true, { expires: 7, path: '/' });
            });

            if ( true !== hasRead ) {
                $modal.modal('show');
            }
		});

	};


	return App;

} )( document, window );

var app = new App();
app.init();